'use client';

import { useHunterPriority } from '../_lib/use-hunter-priority';

export function AmbientDot() {
  const { count, pending } = useHunterPriority();
  const label =
    pending && count > 0
      ? `Hunter has ${count} ${count === 1 ? 'decision' : 'decisions'} waiting`
      : 'Hunter status';

  return (
    <span
      className={`ambient-dot${pending ? ' has-priority' : ''}`}
      aria-label={label}
      title={label}
      role="status"
    />
  );
}
